exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question[data-v-1dc56f5a]{font-weight:700}table td[data-v-1dc56f5a]{text-align:center}.lunar-new-year-bg[data-v-1dc56f5a]{background:url(/images/lunar_new_year_bg.png) no-repeat;background-size:cover}.lunar-new-year-bg[data-v-1dc56f5a],.lunar-new-year-bg a[data-v-1dc56f5a]{color:#000;font-weight:700;font-size:1.2rem}", ""]);

// exports
